<template>
    <div class="box-second">
        <p class="title">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>设备管理</el-breadcrumb-item>
                <el-breadcrumb-item>螺母设备</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="build-bar">
                <el-button type="primary" @click="addRow()">添加螺母主机</el-button>
            </div>
            <div class="build-table">
                <el-table :data="tableDataEnd" ref="tableDataBegin" height="100%" style="width: 100%;">
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="80">
                    <template slot-scope="scope">
                    <span>{{ scope.row.index }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="螺母主机">
                    <template slot-scope="scope">
                    <a @click="toChild(scope.row)">{{ scope.row.name}}</a>
                    </template>
                </el-table-column>
                <el-table-column label="主机使用设备项">
                    <template slot-scope="scope">
                    <span>{{ scope.row.statusName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="所属设备">
                    <template slot-scope="scope">
                    <span>{{ scope.row.towerName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="在线时间">
                    <template slot-scope="scope">
                    <span>{{ scope.row.connectDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                      <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                      <el-button size="mini" type="danger" @click="unBind(scope.$index, scope.row)">解绑螺母</el-button>
                    </template>
                </el-table-column>

                <!-- 新增窗口 -->
                <el-dialog
                    :title="dialogTitle"
                    :visible.sync="addFormVisible"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    class="add-form"
                    width="30%"
                >
                    <el-form
                    :model="addForm"
                    ref="addForm"
                    label-width="160px"
                    :label-position="labelPosition"
                    :rules="rules"
                    >
                    <el-form-item label="设备名称：">
                        <el-input v-model="addForm.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="设备序列号：" prop="deviceId">
                        <el-input v-model="addForm.deviceId" placeholder="请输入" autocomplete="off"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="主机使用设备项：">
                        <el-select v-model="addForm.nutUseType">
                        <el-option
                            v-for="item in typeNameAll"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="绑定塔吊：">
                        <el-select v-model="addForm.towerId">
                        <el-option
                            v-for="item in towerList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="厂家：">
                        <el-select v-model="addForm.machType">
                        <el-option
                            v-for="item in millNameAll"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="位置:">
                        <el-input type="textarea" v-model="addForm.locationDesc"></el-input>
                    </el-form-item> -->
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                    <el-button @click="addFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                    </div>
                </el-dialog>
                </el-table>

                <!-- 表单列表 -->
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 20,50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../../untils/util'
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
export default {
    data() {
    return {
      // projectId: '',
      typeNameAll: [
        // { status: '进闸', value: '0' },
        // { status: '出闸', value: '1' },
        // { status: '未配置', value: '2' },
        // { status: '采集机', value: '4' },
        // { status: '特种使用', value: '5' }
      ], // 类型下拉菜单组
      status: '进闸', // 类型下拉菜单默认值
      millNameAll: [], // 厂家下拉菜单组
      machType: '零视', // 厂家下拉菜单默认值
      dialogTitle: '', //弹出框标题
      labelPosition: 'right', // 添加设备弹出框position属性
      addForm: {
        id:'',
        name:'',
        deviceId:'',
        nutUseType:'',
        towerId:''
      }, // 添加设备表单数组
      addFormVisible: false, // 弹出框是否显示
      tableDataEnd: [], // 考勤机表单数据
      currentPage: 1, // 表单列表默认页
      pageSize: 10, // 表单列表默认显示数
      totalItems: 0, // 表单列表全部长度
      projectName: '',
      groupId: util.session.get('groupId'),
      dataText: '数据加载中...',
      rules: {
        deviceId: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        // nutUseType: [
        //   { required: true, message: '请选择', trigger: 'blur' }
        // ],
      },
      towerList:[],
    }
  },
  mounted() {
    // this.getData()
    //this.getList()
    this.getDict()
    // this.getDict1()
    this.getTowerList()

  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getList()
    },
    // 监控当前页码
    currentChangePage() {
      this.getList()
    },

    // 获取数据
    // getData() {
    //     var that = this
    //     myHttp.getProjectById({
    //       id: util.session.get('groupId')
    //     }).then(
    //       function(resp) {
    //         if (resp.data.code == '200') {
    //           that.projectName = resp.data.data.project.name
    //         }
    //       },
    //       function() {}
    //     )
    // },

    //获取列表
    getList() {
      var option = {
        projectId: util.session.get('groupId'),
        pageSize:this.pageSize,
        pageNum:this.currentPage
      }
      var that = this
      myHttp.selectNutHostListPage(option).then(
        function(resp) {
          //var projectName = "";
          if (resp.data.code == '200') {
            var list = resp.data.data.PageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              //that.projectName = list[i].projectName;
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              list[i].statusName = that.filterSatus(list[i].nutUseType)
            }
            that.tableDataEnd = list
            console.log(list)
            that.totalItems = resp.data.data.PageInfo.total||0
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },

    //获取塔吊设备
    getTowerList(){
      var that = this
      myHttp.getListByTowerProjectId({
        projectId:this.groupId
      }).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.towerList || []
            // for (var i = 0; i < list.length; i++) {
            //   list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            // }
            that.towerList = list
            // that.totalItems = list.length
            // if (that.tableDataEnd.length == 0) {
            //   that.dataText = '暂无数据'
            // }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },

    //获取类型
    filterSatus(str){
      var list = this.typeNameAll
      var result = ''
      for(var i=0;i<list.length;i++){
        if(str == list[i].value){
          result = list[i].label
        }
      }
      return result
    },

    // 编辑数据
    handleEdit(index, row) {
      this.dialogTitle = '编辑设备信息'
      this.addFormVisible = true
      // this.addForm = row
      this.addForm.id = row.id
      this.addForm.deviceId = row.deviceId
      this.addForm.nutUseType = row.nutUseType
      this.addForm.name = row.name
      this.addForm.projectId = row.projectId
      this.addForm.towerId = row.towerId
    },

    // 删除数据 111
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.deleteNutHost({
            id: row.id,
            updateBy:util.session.get('user').id
        }).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('删除成功')
            that.getList()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      })
    },

    /**
     * 新增设备
     */
    addRow() {
      this.dialogTitle = '添加螺母主机'
      this.addFormVisible = true
      this.addForm = {
        deviceId: '',
        name: '',
        nutUseType: '',
        id: '',
        projectId: util.session.get('groupId'),
        createBy:''
      }
    },

    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.addForm.id == '') {
            that.addForm.projectId = that.groupId
            that.addForm.nutUseType = '1'
            that.addForm.createBy = util.session.get("user").id
            //添加
            myHttp.postNutHost(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.currentPage = 1
                  that.getList()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          } else {
            //修改 1111
            delete that.addForm.createDate
            delete that.addForm.updateDate
            delete that.addForm.connectDate
            that.addForm.projectId = that.groupId
            that.addForm.updateBy = util.session.get("user").id
            myHttp.updateNutHost(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.addFormVisible = false
                  that.getList()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          }
        }
      })
    },
    cancel() {
      this.addFormVisible = false
    },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    // 字典接口
    // getPageList
    getDict() {
      var that = this
      myHttp.getDictByType({
          type: 'nut_use_type'
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            that.typeNameAll = resp.data.data.dictList
            that.getList()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    // getDict1() {
    //   var that = this
    //   myHttp
    //     .getDictByType({
    //       type: 'mach_type'
    //     })
    //     .then(function(resp) {
    //       if (resp.data.code == '200') {
    //         that.millNameAll = resp.data.data.dictList
    //       } else {
    //         that.$message.error(resp.data.msg)
    //       }
    //     })
    // }
    //跳转
    toChild(row){
      console.log(111)
      this.$router.push({path:'/nut/'+row.id})
    },
    //解绑
    unBind(index,row){
      var that = this
      this.$confirm('此操作将解绑所有的螺母, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.unbundlingNut({
            id: row.id,
        }).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('解绑成功')
            that.getList()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      })
    },
  }
}
</script>
<style scoped>
    .box-second{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .title{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    .main{
        width: 100%;
        height: calc( 100% - 3vh );
        position: relative;
        display: flex;
        padding: 0 1vw 0.5vw;
        flex-wrap: wrap;
        align-content: flex-start;
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 8vh;
        /* border-top: 3px solid rgb(224, 224, 224); */
        border-bottom: 3px solid #17b2fe;
        background: #fff;
    }

    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }

    .build-bar > .el-button {
        margin-left: 30px;
        background-color: #17b2fe;
        border-color: #17b2fe;
    }

    .build-bar > .el-button:last-child {
        margin-right: 20px;
    }

    .build-bar .btnLef {
        position: absolute;
        right: 6%;
        display: block;
        width: 95px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        border-radius: 4px;
        background: #ffaf15;
        border: 1px solid #ffb800;
    }

    .el-select .el-input {
        width: 130px;
    }

    .input-with-select .el-input-group__prepend {
        background-color: #fff;
    }

    .build-table {
        position: relative;
        width: 100%;
        background: #fff;
        height: calc( 100% - 13vh );
        /* margin: 0 auto; */
    }

    .el-table .el-table-column:not(:first-child) {
        border: 1px solid slategrey;
    }

    .el-table >>> .cell {
        overflow: hidden;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
    }

    .add-form {
        margin-top: 10vh;
    }

    .add-form .el-form-item {
        margin-top: 30px;
    }

    .el-pagination {
        padding: 20px 0;
    }
</style>
<style>
@import '../../../assets/css/common.css';
</style>